module.exports = __webpack_public_path__ + "media/eyezen-boost_livre.83470543.mp4";